import React from 'react'
import styles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';
import Button from '../common/ui-components/input/Button';
import UIModal from '../common/ui-components/surface/UIModal';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import { changeProgress, pushToTicketList } from '../../redux/actions/selfserveActions';
import { useDispatch } from 'react-redux'
import { HOMECARE_PLAN_LIST } from '../../constants/index';

interface Props{
    setEnableModal: any,
    allInvalid: boolean,
    is_open: boolean,
    parentPlanDetails: any,
}

const InvalidIssueAlert = (props: Props) => {

    const dispatch:any = useDispatch();
    const allInvalid = props.allInvalid;

    const close = () => {
        // setOpen(false)
        props.setEnableModal(false);
        return false
    }

    const proceed = () => {
        // setOpen(false);
        close();
        if(HOMECARE_PLAN_LIST.includes(props.parentPlanDetails.plan_name)){
            dispatch(pushToTicketList());
            dispatch(changeProgress(15));
        }else{
            dispatch(changeProgress(7));
        }
    }

    const alertTitle = allInvalid ? "Attention Needed!" : "Important Note!"
    const alertText = allInvalid ? "Selected issues are not covered under your Onsitego Plan. Please update the issues to proceed further." : "There are some issues/spare parts that are not covered under your Onsitego Plan. You may have to pay an additional amount for spare parts that need to be replaced."


    return (
        <UIModal isOpen={props.is_open} onClick={close} larger={false} boxClass={styles.apply_box}>
            <div className={styles.selfserve_alert}>
                <h5 className={styles.selfserve_alert__title}>{alertTitle}</h5>
                <div className={styles.selfserve_alert__text}>
                    <p>{alertText}</p>
                </div>
            

                {
                    allInvalid ?
                        <div className={commonStyles.single_button} >
                            <Button
                                className={commonStyles.single_btn}
                                onClick={close}
                                text="Ok"
                                variant="secondary"
                                style={{'width': '200px','fontSize': '14px'}}
                            />
                        </div>
                        :
                        <div className={commonStyles.single_button} >
                            <Button
                                className={commonStyles.single_btn}
                                onClick={proceed}
                                text="Proceed"
                                style={{'width': '200px','fontSize': '14px'}}
                            />
                        </div>
                }       

            </div>
        </UIModal>
    )
}

export default InvalidIssueAlert